"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepperNavigationLocationEnum = void 0;
var StepperNavigationLocationEnum;
(function (StepperNavigationLocationEnum) {
    StepperNavigationLocationEnum["LEFT"] = "left";
    StepperNavigationLocationEnum["RIGHT"] = "right";
    StepperNavigationLocationEnum["TOP"] = "top";
    StepperNavigationLocationEnum["BOTTOM"] = "bottom";
})(StepperNavigationLocationEnum || (exports.StepperNavigationLocationEnum = StepperNavigationLocationEnum = {}));
